// extracted by mini-css-extract-plugin
export default {"title":"style_title__RJU2l","data":"style_data__GuBQK","item":"style_item__csb95","items":"style_items__IlL4k"};